import { render, staticRenderFns } from "./DunningCampaignBuilder.vue?vue&type=template&id=203953f9&scoped=true&"
import script from "./DunningCampaignBuilder.vue?vue&type=script&lang=js&"
export * from "./DunningCampaignBuilder.vue?vue&type=script&lang=js&"
import style0 from "./DunningCampaignBuilder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DunningCampaignBuilder.vue?vue&type=style&index=1&id=203953f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203953f9",
  null
  
)

export default component.exports